import { bulkConfigurationApiUrl } from "../../bulkBaseUrl";

export const dataSourcesUrl = `${bulkConfigurationApiUrl}/dataSources`;

/** Key for identifying and caching {@link https://react-query.tanstack.com/overview react-query} requests */
export const savedExportSettingsKey = "savedExportSettings";